module.exports = __webpack_public_path__ + "img/earth-asia.01f3bae1.svg";